import {NgModule} from '@angular/core';
import {SharedModule} from '../../../../core/shared.module';
import {NgbModalModule} from '@ng-bootstrap/ng-bootstrap';
import {BusinessOrderStartModalComponent} from './business-order-start-modal.component';
import {BusinessOrderStartErrorsReactComponent} from './business-order-start-errors-react.component';

@NgModule({
    imports: [
        NgbModalModule,
        SharedModule,
        BusinessOrderStartErrorsReactComponent,
    ],
    declarations: [
        BusinessOrderStartModalComponent
    ]
})
export class BusinessOrderStartModule {
}
